import urls from "../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../utils/service";

export const getTasksData = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.tasksApi, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const saveTasks = async (body: any) => {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.tasksApi, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateTasks = async (body: any) => {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(`${urls.tasksApi}/update`, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
